import { Button, ButtonGroup, buttonName, useItemNames } from '@ps-smart-cp/ppfw-client';

interface ToDetailsInputButtonGroupProps {
  onToDetailsInput?: (() => Promise<void>) | (() => void);
  onReset?: (() => Promise<void>) | (() => void);
  isToDetailsInput?: boolean;
  isResetDisabled?: boolean;
}

export function ToDetailsInputButtonGroup({
  onToDetailsInput,
  onReset,
  isToDetailsInput,
  isResetDisabled,
}: ToDetailsInputButtonGroupProps) {
  const getButtonName = useItemNames(buttonName);

  return (
    <ButtonGroup alignment="right">
      <Button
        label={getButtonName('toDetailsInput')}
        onClick={onToDetailsInput}
        disabled={isToDetailsInput}
      />
      <Button label={getButtonName('reset')} onClick={onReset} disabled={isResetDisabled} />
    </ButtonGroup>
  );
}
